import { CoreSetupAuditTrailViewsName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { getCoreSetupAuditTrailViewsSlice } from './get';
import { SetupAuditTrailView } from '@types';

export const updateCoreSetupAuditTrailViewsSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreSetupAuditTrailViewsName,
	state: getCoreSetupAuditTrailViewsSlice.asyncState,
	target: (update: Partial<SetupAuditTrailView>) => (entry) => entry.id === update.id,
	update: (update: Partial<SetupAuditTrailView>) => (entry) => ({
		...entry,
		...update
	})
});
